import { ICalpuffConfiguration } from 'es/app/business-logic/domain-models/ICalpuffConfiguration';
import { action, computed, makeObservable } from 'mobx';
import EntityStore from 'es/app/store/EntityStore';
import { fetchCalpuffConfigurations } from 'es/app/business-logic/services/modelling/modellingService';

export default class CalpuffConfigurationStore extends EntityStore<ICalpuffConfiguration> {
    constructor() {
        super();
        makeObservable(this, {
            calpuffConfigurations: computed,
            load: action.bound,
        });
    }

    public get calpuffConfigurations(): ICalpuffConfiguration[] {
        return this.entities;
    }

    public async load(): Promise<ICalpuffConfiguration[]> {
        if (this.entities?.length) return this.entities;

        const calpuffConfigurations = await fetchCalpuffConfigurations();
        this.reset(calpuffConfigurations);
        return calpuffConfigurations;
    }
}
